import { z } from 'zod';
import { idSchema, timestamps } from './utility';

export const paymentSchema = z.object({
  id: idSchema,
  model_type: z.string(),
  model_id: idSchema,
  amount: z.number(),
  payment_method: z.enum(['card', 'bank_transfer']),
  ...timestamps,
});